import Axios from 'axios'
const API_HOST = process.env.VUE_APP_API_HOST
const API_VERSION = process.env.VUE_APP_API_VERSION
const ScenarioService = {
  /**
   * @description Get all scenario list data
   *
   * @returns {object}
   */
  getScenariosList(q, sort, page = 1, perPage = 1000) {
    const getScenariosURL = `${API_HOST}/${API_VERSION}/listen/scenarios`
    const params = {
      q: q,
      sort,
      page,
      per_page: perPage
    }
    return Axios
      .get(getScenariosURL, {
        headers: {
          Accept: 'application/json'
        },
        params
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  getScenario(scenarioId) {
    const getScenarioURL = `${API_HOST}/${API_VERSION}/listen/scenarios/${scenarioId}`
    return Axios
      .get(getScenarioURL, {
        headers: {
          Accept: 'application/json'
        }
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  }
}
export default ScenarioService
